<template>
	<VueApexCharts type="line" :height="height" :options="chartOptions" :series="series"></VueApexCharts>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
	name: "GraficoLineDashboard",
	components: { VueApexCharts },
	props: [
		"dataSeries",
		"categories",
		"height",
		"money",
		"porcent",
		"dataLabels",
		"colors",
		"toolbar",
	],
	data: () => ({
		series: [],
		chartOptions: {
      grid: {
        padding: {
          left: 60, // or whatever value that works
          right: 60 // or whatever value that works
        }
      },
			chart: {
				type: "line",
				locales: [
					{
						name: "pt-BR",
						options: {
							shortMonths: [
								"Jan",
								"Fev",
								"Mar",
								"Abr",
								"Mai",
								"Jun",
								"Jul",
								"Ago",
								"Set",
								"Out",
								"Nov",
								"Dez",
							],
						},
					},
				],
				defaultLocale: "pt-BR",
				toolbar: {
					show: true,
				},
			},
			colors: ["#002D56", "#1764AA", "#45A5FC"],
			dataLabels: {
				enabled: true,
			},
			markers: {
				size: 5,
			},
			tooltip: { y: {} },
			stroke: {
				curve: "straight",
			},
			yaxis: {
				show: false,
			},
			xaxis: {
				categories: [],
			},
			legend: {
				position: "bottom",
			},
		},
	}),
  created() {
    if (this.dataLabels) {
      this.chartOptions.dataLabels.enabled = this.dataLabels;
      this.chartOptions.dataLabels.style = {
        colors: ["#000"], // Cor do texto dos labels (opcional)
      };
      // Evita que os labels sejam cortados nas laterais
      this.chartOptions.dataLabels.offsetX = 5;
      this.chartOptions.dataLabels.offsetY = -5;
      this.chartOptions.dataLabels.floating = true;
    }

    if (this.toolbar !== null) {
      this.chartOptions.chart.toolbar.show = this.toolbar;
    }

    if (this.porcent) {
      this.chartOptions.tooltip.y = {
        enabled: true,
        formatter: function (val) {
          if (val == null || isNaN(val)) return "-";
          return `${parseFloat(val).toFixed(2)}%`;
        },
      };

      // Novo formatter para os dataLabels:
      this.chartOptions.dataLabels.formatter = function (val) {
        if (val == null || isNaN(val)) return "";
        return `${parseFloat(val).toFixed(2)}%`;
      };

      // this.chartOptions.yaxis = {
      //   show: true,
      //   labels: {
      //     formatter: function (val) {
      //       return `${parseFloat(val).toFixed(2)}%`;
      //     },
      //   },
      // };
    } else if (this.money) {
      this.chartOptions.tooltip.y = {
        enabled: true,
        formatter: function (val) {
          if (val == null || isNaN(val)) return "-";
          return parseFloat(val).toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
          });
        },
      };

      // this.chartOptions.yaxis = {
      //   show: true,
      //   labels: {
      //     formatter: function (val) {
      //       if (val == null || isNaN(val)) return "";
      //       return parseFloat(val).toLocaleString("pt-br", {
      //         style: "currency",
      //         currency: "BRL",
      //       });
      //     },
      //   },
      // };

      // Novo formatter para os dataLabels:
      this.chartOptions.dataLabels.formatter = function (val) {
        if (val == null || isNaN(val)) return "";
        return parseFloat(val).toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL",
        });
      };
    } else {
      this.chartOptions.tooltip.y = {
        enabled: true,
        formatter: function (val) {
          if (val == null || isNaN(val)) return "-";
          return parseFloat(val).toLocaleString('pt-BR');
        },
      };

      // Novo formatter para os dataLabels:
      this.chartOptions.dataLabels.formatter = function (val) {
        if (val == null || isNaN(val)) return "";
        return parseFloat(val).toLocaleString('pt-BR');
      };
    }

    this.series = this.dataSeries;
    this.chartOptions.xaxis.categories = this.categories;
    if (this.colors) {
      this.chartOptions.colors = this.colors;
      if (this.dataSeries.length <= 1){
        // this.chartOptions.xaxis.labels.style.colors = this.colors;
      }
    }
  }
};
</script>

<style>
.apexcharts-tooltip {
	background: #ffffff !important;
	color: #023449;
	border-color: #023449 !important;
}

.apexcharts-tooltip-title {
	background-color: #023449 !important;
	color: #ffffff;
}
</style>
